import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui"; //全局引入element
import "element-ui/lib/theme-chalk/index.css"; //全局引入element css
import "@/styles/index.less"; // 全局 css
import VueClipBoard from "vue-clipboard2"; //复制
import vueMiniPlayer from "vue-mini-player"; //视频
import "vue-mini-player/lib/vue-mini-player.css"; //视频样式
import Vant from "vant";
import base from "./utils/base";

// 2. 引入组件样式
import "vant/lib/index.css";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(VueClipBoard);
Vue.use(vueMiniPlayer);
Vue.prototype.$base = base; //全局方法
Vue.prototype.$imgapi = "https://oss.henlv.net/"; //全局方法
// Vue.prototype.$imgapi = "https://henlv.oss-cn-hangzhou.aliyuncs.com/"; //全局方法
// Vue.prototype.$imgapi = "https://hengshuaitest.edochxun.com/"; //全局方法

Vue.directive('animate', {
  inserted: function (el, binding) {
    binding.addClass = () => {
      const { top } = el.getBoundingClientRect()
      const h = document.documentElement.clientHeight || document.body.clientHeight
      if (top < h) {
        if(el.className.indexOf(binding.value) == -1 ){
          el.className = binding.value+' '+el.className
        }
        if (binding.addClass) {
          window.removeEventListener('scroll', binding.addClass)
        }
      }
    }
    window.addEventListener('scroll', binding.addClass,true)
    binding.addClass()
  },
  unbind: function (el, binding) {
    if (binding.addClass) {
      window.removeEventListener('scroll', binding.addClass)
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js